import { useDispatch } from "react-redux";
import { quoteAllClearData } from "../../../store/generateQuote/actions";
var useInsurancePoliciesUI = function (setOpenModal, setOpenModalConfirm, setOpenModalHistorial) {
    var dispatch = useDispatch();
    var handleOpenModal = function () {
        setOpenModal(true);
        setOpenModalConfirm(false);
    };
    var handleCloseModal = function () {
        setOpenModal(false);
        setOpenModalConfirm(false);
        setOpenModalHistorial(false);
        dispatch(quoteAllClearData());
    };
    var handleOpenModalConfirm = function () {
        setOpenModalConfirm(true);
        setOpenModal(false);
    };
    var handleCloseModalConfirm = function () {
        setOpenModal(false);
        setOpenModalConfirm(false);
    };
    var handleConfirm = function () {
        setOpenModalConfirm(true);
        setOpenModal(false);
    };
    return {
        handleOpenModal: handleOpenModal,
        handleCloseModal: handleCloseModal,
        handleOpenModalConfirm: handleOpenModalConfirm,
        handleCloseModalConfirm: handleCloseModalConfirm,
        handleConfirm: handleConfirm,
    };
};
export default useInsurancePoliciesUI;
